import { takeLatest, call, put, fork, all } from 'redux-saga/effects';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { hide } from 'redux-modal';
import { reset } from 'redux-form';
import { normalize } from 'normalizr';
import API from 'services/NGWordApi';
import * as actions from 'actions/ngwords';
import * as schemas from 'schemas/ngwords';
import * as actionTypes from 'actionTypes/ngwords';
import * as entityActions from 'actions/entities';
import * as listActions from 'actions/lists';
import * as coreSagas from 'sagas/core';
import * as constants from 'misc/constants';
import { setLoading } from 'actions/loading';

function* list(action) {
  const { params } = action.payload;
  yield put(setLoading(constants.NG_WORD, true));
  try {
    const response = yield call(API.list, decamelizeKeys(params));
    const normalized = normalize(camelizeKeys(response.data.results), [schemas.ngWordSchema]);
    const totalCount = response.data.count ? response.data.count : 1;
    yield put(entityActions.merge(normalized.entities));
    yield put(listActions.setPaginationResult(
      constants.NG_WORD,
      params.page,
      normalized.result,
      totalCount
    ));
    yield put(setLoading(constants.NG_WORD, false));
  } catch (error) {
    yield put(actions.listFailure(error));
    yield put(setLoading(constants.NG_WORD, false));
  }
}

// Create ======================================================================
function* create(action) {
  const { values } = action.payload;
  yield put(setLoading(constants.NG_WORD_ADD_MODAL, true));
  try {
    const response = yield call(API.create, decamelizeKeys(values));
    const normalized = normalize(camelizeKeys(response.data), schemas.ngWordSchema);
    yield put(entityActions.merge(normalized.entities));
    yield put(listActions.addPaginationItem(constants.NG_WORD, normalized.result))
    yield fork(coreSagas.successNotification, 'NG Word added successfully.');
    yield put(hide(constants.NG_WORD_ADD_MODAL));
    yield put(reset(constants.NG_WORD_ADD_FORM));
    yield put(setLoading(constants.NG_WORD_ADD_MODAL, false));
  } catch (error) {
    yield put(actions.createFailure(error));
    yield put(setLoading(constants.NG_WORD_ADD_MODAL, false));
  }
}

function* batchDelete(action) {
  const message = `Are you sure to delete selected NG Words?`;
  const confirmed = yield call(coreSagas.confirm, message);
  if (confirmed) {
    const { values } = action.payload;
    yield put(setLoading(constants.CONFIRM_MODAL, true))
    try {
      yield call(API.batchDelete, decamelizeKeys(values));
      yield all(values.items.map(id => put(listActions.removePaginationItem(constants.NG_WORD, id))));
      yield fork(coreSagas.successNotification, 'NG Words deleted successfuly.');
      yield put(hide(constants.CONFIRM_MODAL));
      yield put(setLoading(constants.CONFIRM_MODAL, false))
    } catch (error) {
      yield put(actions.batchDeleteFailure(error));
      yield put(setLoading(constants.GLOSSARY_LIST, false));
    }
  }
}

function* watchCreate() {
  yield takeLatest(actionTypes.CREATE.REQUEST, create);
}
function* watchList() {
  yield takeLatest(actionTypes.LIST.REQUEST, list);
}
function* watchBatchDelete() {
  yield takeLatest(actionTypes.BATCH_DELETE.REQUEST, batchDelete);
}

export {
  watchCreate,
  watchList,
  watchBatchDelete,
}